import React from 'react';
import { DimensionProcessingStatus } from '../../types';
import { PhaseIndicator } from './PhaseIndicator';
import { CurrentPartCard } from './CurrentPartCard';
import { DeduplicationStatsPanel } from './DeduplicationStatsPanel';
import { RecentEventsLog } from './RecentEventsLog';
import { AlertsBanner } from './AlertsBanner';

interface DimensionProcessingStatusProps {
  job: DimensionProcessingStatus;
}

export const DimensionProcessingStatusComponent: React.FC<DimensionProcessingStatusProps> = ({ job }) => {
  const details = job.processing_details;

  if (!details) return null;

  return (
    <div className="space-y-4">
      {/* Alerts (if any) */}
      {details.alerts && details.alerts.length > 0 && (
        <AlertsBanner alerts={details.alerts} />
      )}

      {/* Phase Indicator */}
      {details.current_phase && details.phase_name && (
        <PhaseIndicator
          currentPhase={details.current_phase}
          phaseName={details.phase_name}
          phaseProgress={details.phase_progress}
        />
      )}

      {/* Current Part (if processing) */}
      {details.current_part && (
        <CurrentPartCard part={details.current_part} />
      )}

      {/* Two-column layout for stats and events */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Deduplication Stats */}
        {details.stats && (
          <DeduplicationStatsPanel stats={details.stats} currentPhase={details.current_phase} />
        )}

        {/* Recent Events */}
        {details.recent_events && details.recent_events.length > 0 && (
          <RecentEventsLog events={details.recent_events} />
        )}
      </div>
    </div>
  );
};
